import { ActiveRecord, sources } from '@mysidewalk/active-record';
import { DataReferenceQuery } from '../data/index.js';
import Attribution from './Attribution.js';
import Description from './Description.js';
/**
 * @classdesc
 *
 * @memberof system-metadata
 * @property {number} id
 * @property {string} friendlyName
 * @property {string[]} names
 * @property {system-metadata.Attribution} attribution
 * @property {system-metadata.Description} description
 */
class Dimension extends ActiveRecord {
    initialize(props) {
        super.initialize(props);
        this.attribution = new Attribution(this.attribution);
        this.description = new Description(this.description);
    }
    /**
     * @param {object} parameters
     * @return {data-references.DataReferenceQuery}
     */
    toDataReferenceQuery(parameters) {
        return DataReferenceQuery.system({
            dimensions: [...this.names],
            ...(parameters || {}),
        });
    }
}
Dimension.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
export default Dimension;
